export default [
  {
    path: "/pertanian",
    component: () => import("@/pages/pertanian/pertanian-list.vue"),
    meta: {
      requiredLevel: ["admin", "pertanian"],
    },
  },
  {
    path: "/pertanian/import",
    component: () => import("@/pages/pertanian/pertanian-import.vue"),
    meta: {
      requiredLevel: ["admin", "pertanian"],
    },
  },
];
